import { WorkOrderStatuses } from "~/workorder/types";
import moment from "moment";
import { formatDate } from "~/app/helpers/date";

export const canEditWorkOrderMechanics = (status: number): boolean => (
    status !== WorkOrderStatuses.APPROVED
    && status !== WorkOrderStatuses.FINISHED
);

export const canEditWorkOrderPlannedDates = (status: number): boolean => (
    status === WorkOrderStatuses.OPEN
    || status === WorkOrderStatuses.PLANNED
    || status === WorkOrderStatuses.DELAYED
);

export const canEditWorkOrderCommentAndDescription = (status: number): boolean => (
    status !== WorkOrderStatuses.APPROVED
);

const PICKER_FORMAT = 'YYYY-MM-DD[T]HH:mm';
const API_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const scheduledDateApiToPicker = (apiValue?: string | null): string => {
    if (!apiValue || !String(apiValue).trim()) {
        return '';
    }
    return formatDate(apiValue, PICKER_FORMAT);
};

export const scheduledDatePickerToApi = (pickerValue: string): string => {
    if (!pickerValue || !String(pickerValue).trim()) {
        return '';
    }
    const parsed = moment(pickerValue);
    return parsed.isValid() ? parsed.format(API_DATETIME_FORMAT) : '';
};

export const isScheduledEndBeforeStart = (start: string, end: string): boolean => {
    const startTrimmed = String(start ?? '').trim();
    const endTrimmed = String(end ?? '').trim();
    if (!startTrimmed || !endTrimmed) {
        return false;
    }
    const startMoment = moment(startTrimmed);
    const endMoment = moment(endTrimmed);
    if (!startMoment.isValid() || !endMoment.isValid()) {
        return false;
    }
    return endMoment.isSameOrBefore(startMoment);
};

const formatDayMonthYearTime = (date: string): string => moment(date).format('DD. MMM YY HH:mm');

export const formatWorkOrderDetailDate = (date?: string | null): string | null => {
    if (!date) {
        return null;
    }
    const parsed = moment(date);
    return parsed.isValid() ? formatDayMonthYearTime(date) : null;
};

export const formatWorkOrderDetailDateRange = (
    start?: string,
    end?: string,
): string | null => {
    if (!start && !end) {
        return null;
    }
    if (start && end) {
        const startFormatted = formatDayMonthYearTime(start);
        const endFormatted = formatDayMonthYearTime(end);
        if (startFormatted && endFormatted) {
            return `${startFormatted} – ${endFormatted}`;
        }
    }
    if (start) {
        return formatDayMonthYearTime(start);
    }
    return end ? formatDayMonthYearTime(end) : null;
};